import type { PromoteDialogTarget } from '../reservation-dialogs-host';
import type { QueueEntryView } from '../components/reservation-queue-list';
import type { PromoteCurrentSummarySource } from '../components/queue-promote-dialog';

interface PromoteRow extends PromoteCurrentSummarySource {
  id: number;
  dateFrom: string;
  dateTo: string;
}

/** The displace-and-promote confirmation needs both the held reservation and the chosen queue entry on screen. */
export function resolvePromoteTarget(
  target: { reservationId: number; entryId: number } | null,
  rows: readonly PromoteRow[],
  queueByReservationId: Record<number, QueueEntryView[]>,
  mediaUnitName: string,
): PromoteDialogTarget | null {
  if (!target) return null;
  const reservation = rows.find((row) => row.id === target.reservationId);
  const entry = queueByReservationId[target.reservationId]?.find((e) => e.id === target.entryId);
  if (!reservation || !entry) return null;
  return {
    mediaUnitName,
    dateFrom: reservation.dateFrom,
    dateTo: reservation.dateTo,
    current: reservation,
    next: entry,
  };
}
